/** @jsx jsx */
import { jsx } from '@emotion/core'
import { observer } from 'mobx-react'
import React, { Fragment, useState } from 'react'
import { AdvButton, CloseBtnStyle } from '@components/Button'
import PopupUtils from '@utils/popup-utils'
import styled from '@themes/theme'
import StorageUtils from '@utils/storage-utils'
import useRootStore from '@store/useRootStore'
// img
import userPickPromotionBannerMatchupImg from '@assets/images/banner/user-pick-product/user-pick-propmotion-banner-matchup.png'
import userPickPromotionBannerImg from '@assets/images/banner/user-pick-product/user-pick-propmotion-banner.png'

const UserPickPromotionBannerWrap = styled.div`
  position: absolute;
  bottom: -13px;
  right: calc(100% + 4px);

  img {
    width: auto;
    height: 100%;
  }

  .close-btn {
    position: absolute;
    right: initial;
    top: 8px;
    left: -10px;

    &::before, &::after {
      background: ${props => props.theme.color.subColor2};
    }

    .bg {
      background: ${props => props.theme.color.darkTxt};
      box-shadow: 2px 2px 3px rgba(0, 0, 0, .08);
    }
  }

  &.bottom-banner {
    right: initial;
    bottom: -42px;
    left: 50%;
    transform: translateX(-68%);

    .close-btn {
      top: 10px;
      left: -17px;
    }
  }
`

export interface Props {
  className?: string
  bottom?: boolean
}

export const UserPickPromotionBanner: React.FC<Props> = observer((props): React.ReactElement => {
  const { authStore } = useRootStore()
  const { className, bottom } = props
  const { isSignedIn } = authStore
  const visibleBannerInit = isSignedIn && !StorageUtils.isUserPickPromotionBannerHide()
  const [visibleBanner, setVisibleBanner] = useState(visibleBannerInit)

  const onClickUserPickPromotionBanner = () => {
    setVisibleBanner(false)
    PopupUtils.showUserPickGiveawayInfo()
    StorageUtils.saveUserPickPromotionBannerHide()
  }

  const onCloseUserPickPromotionBanner = () => {
    setVisibleBanner(false)
    StorageUtils.saveUserPickPromotionBannerHide()
  }

  let contents
  if (bottom) {
    contents = <img src={userPickPromotionBannerMatchupImg} alt="새로 작성된 분석글을 확인하세요!" loading="lazy"/>
  } else {
    contents = <img src={userPickPromotionBannerImg} alt="분석글 작성하고 매일 선물받자!" loading="lazy"/>
  }

  const clsIco = (
    <Fragment>
      <div className="bg"/>
      <span className="close-txt">닫기</span>
    </Fragment>
  )

  return (
    <Fragment>
      {visibleBanner &&
        <UserPickPromotionBannerWrap className={bottom && 'bottom-banner'}>
          <AdvButton
            height={bottom ? 43 : 65}
            contents={contents}
            className={className}
            onClick={onClickUserPickPromotionBanner}
          />
          <AdvButton
            flex
            alignCenter
            width={40}
            height={40}
            borderRadius={'50%'}
            txtAlignCenter
            contents={clsIco}
            className="close-btn"
            css={CloseBtnStyle}
            onClick={onCloseUserPickPromotionBanner}
          />
        </UserPickPromotionBannerWrap>
      }
    </Fragment>
  )
})
